<template>
  <div>
    <PageTitle v-bind:title="'Heads'" />

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <b-button
            v-if="config.editable"
            variant="primary"
            size="sm"
            :disabled="!$store.getters.checkRole('legam.scripta.head.add')"
            class="float-right mb-4"
            v-b-modal.modal-new-head
          >
            <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
            Add new head
          </b-button>
          <b-modal
            v-if="config.editable"
            id="modal-new-head"
            title="New head"
            ok-title="Save"
            @ok="saveHead"
            size="lg"
          >
            <HeadNewEdit />
          </b-modal>
          <LegamDataTables v-bind="$data" @click="tableClick" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
* >>> .tdAction {
  width: 150px;
}
</style>

<script>
import router from "@/router";
import PageTitle from "@/components/PageTitle.vue";
import LegamDataTables from "@/components/LegamDataTables.vue";
import tdColAction from "@/components/tdColAction";
import HeadNewEdit from "@/components/Scripta/HeadNewEdit";
import HelpStore from "@/store/helpstore.js";
import config from '@/config.js'

export default {
  name: "Heads",
  data() {
    return {
      columns: [
        {
          title: "Form",
          field: "form",
          sortable: true,
          searchable: true,
        },
        {
          title: "Comment",
          field: "comment",
          sortable: true,
          searchable: true,
        },
        {
          title: "Number Taggings",
          field: "numberTaggings",
          sortable: true,
          searchable: false,
        },
        {
          title: "Action",
          field: "action",
          tdComp: tdColAction,
          thClass: "tdAction",
          transformData: function (row) {
            return [
              {
                text: 'Details',
                icon: "list-ul",
                id: row.id,
                class: "mb-1",
                to: {
                  name: "HeadDetails",
                  params: {
                    id: row.id,
                  },
                },
              },
              {
                text: 'HCC export',
                icon: "arrow-down-circle",
                class: "mb-1",
                dataId: row.id,
              },
            ];
          },
        },
      ],
      url: "/heads/datatables",
      searchableByColumn: true,
      config: config
    };
  },
  components: {
    PageTitle,
    LegamDataTables,
    HeadNewEdit,
  },
  methods: {
    tableClick(dataId) {
      window.location = `${config.apiUrl}/head/${dataId}/export`
    },
    saveHead() {
      this.$store.dispatch("createHead", HelpStore.item).then((response) => {
        router.push(`/head/${response.data.id}`);
      });
    },
  },
};
</script>
